import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'uni-cards',
  templateUrl: './uni-cards.component.html',
  styleUrls: ['./uni-cards.component.scss'],
})
export class UniCardsComponent {
  @Input() class = '';
  @Input() size = 'default';

  @HostBinding('class') get getClasses(): string {
    return `${this.class} uni-card--${this.size}`;
  }
}
